import { Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronLeft } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "src/components/shared/Button/Button";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi } from "src/hooks";
import { type IHistoryItem } from "src/interfaces";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setModalProps } from "src/redux/slices/medicalHistorySlice";
import { StyledTable, StyledTh } from "src/styled";

import { getMedIdType } from "../utils/getMedIdType";
import ModalGenerator from "./ModalGenerator";
import ModalItem from "./ModalItem";

const MedicalHistoryModal = () => {
  const [opened, { open, close }] = useDisclosure();
  const { userid } = useParams();
  const dispatch = useDispatch();
  const { modalProps } = useSelector(state => state.medicalHistory);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const { data, refetch, isLoading } = useGetApi<{ list: IHistoryItem[] }>({
    request: "get-med-row-history",
    body: {
      params: {
        userid,
        section: modalProps?.section,
        ...(modalProps?.id
          ? { [getMedIdType(modalProps?.section)]: modalProps?.id }
          : { archived: true }),
      },
    },
    fetchOnInit: false,
  });
  useEffect(() => {
    if (modalProps) {
      void refetch();
      open();
    }
  }, [modalProps, open, refetch]);
  const handleClose = () => {
    dispatch(setModalProps(null));
    setSelectedRow(null);
    close();
  };
  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      size="90%"
      title={`History ${!modalProps?.id ? "of archived rows" : "of row"}`}>
      {isLoading && <Loader />}
      {selectedRow ? (
        <div>
          <Button
            leftSection={<IconChevronLeft />}
            onClick={() => setSelectedRow(null)}>
            Go back
          </Button>
          <ModalGenerator dataKey={modalProps?.section} row={selectedRow} />
        </div>
      ) : data && data?.list?.length > 0 ? (
        <StyledTable>
          <thead>
            <StyledTh>Action</StyledTh>
            <StyledTh>Date</StyledTh>
            <StyledTh>Rank</StyledTh>
            <StyledTh>Name</StyledTh>
            {!modalProps?.id && <StyledTh>View</StyledTh>}
          </thead>
          {data.list?.map(el => (
            <ModalItem key={el.hid} {...el} setSelectedRow={setSelectedRow} />
          ))}
        </StyledTable>
      ) : (
        <Text ta="center">No history data</Text>
      )}
    </Modal>
  );
};
export default MedicalHistoryModal;
